/* cert/reducer */
import { createReducer } from "typesafe-actions";
import { CertActionTypes, CertState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
} from "./actions";

export const initialState: CertState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>;

export default createReducer<CertState, ActionType>(initialState)
  .handleType(CertActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(CertActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(CertActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(CertActionTypes.SAVE_REQUEST, (state) => {
    return {
      ...state,
      loading: true,
      errors: undefined
    };
  })
  .handleType(CertActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(CertActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  })
  .handleType(CertActionTypes.DELETE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(CertActionTypes.DELETE_SUCCESS, (state) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
    };
  })
  .handleType(CertActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  });
